import styled from '@emotion/styled';
import { Table } from '@mui/material';

export default styled(Table)`
  margin-bottom: 24px;
`;
